<template>
    <div>

        <span v-if="type == 3 || type == 4">
            <el-upload
                class="files-to-upload"
                :action="uploadUrl"
                :file-list="fileList"
                :show-file-list="false"
                accept=".pdf, .png, .jpg, .jpeg, .zip"
                :before-upload="beforeUpload"
                :on-progress="onProgress"
                :on-success="uploadedFile"
                :on-error="onError">
                <el-button
                    size="small"
                    type="primary"
                    v-text="buttonText">
                </el-button>
            </el-upload>
        </span>

    </div>
</template>
<script>
    export default {
        mounted() {
            this.uploadUrl = '/api/save-public-file/'+this.type;
           /* this.api_token = 'Bearer ' +  window.sessionStorage.getItem('sipac_token');*/
        },
        created() {
            if(this.type == 1){
                axios.get('/api/papers/get-last-element', {responseType: 'blob'})
                    .then(response => {
                        if (!response.data.success) {
                            this.$store.dispatch('notifications/info', {msg: 'No se han configurado elementos.'}, {root: true});
                        } else {
                            let blob = new Blob([response.data], {type: response.data.type});
                            this.documentUrl = URL.createObjectURL(blob);
                        }

                    })
                    .catch(error => {
                        this.$store.dispatch('notifications/error', {msg: 'No se pudo generar.'}, {root: true});
                        console.log("error", error);
                    });
            }

        },
        props: {
            buttonName: {},
            index: {},
            type: {}
        },
        data() {
            return {
                disabled: false,
                dialogImageUrl: '',
                dialogVisible: false,
                fileList: [],
                uploadUrl: "",
                api_token: "",
                documentUrl: null
            };
        },
        computed: {
            buttonText: {
                get: function () {
                    const DEFAULT_BUTTON_TEXT = "Clic para subir archivo";
                    if (!this.buttonName) {
                        return DEFAULT_BUTTON_TEXT;
                    }
                    return this.buttonName
                }
            }
        },
        methods: {
            handleRemove(file) {
                console.log(file);
            },
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            handleDownload(file) {
                console.log(file);
            },

            beforeUpload(file) {
                let _this = this;
                let isPDF = false;
                if (file.type === 'image/jpeg' ||
                    file.type === 'image/jpg' ||
                    file.type === 'image/x-png' ||
                    file.type === 'image/png' ||
                    file.type === 'application/zip' ||
                    file.type === 'application/zip' ||
                    file.type === 'application/x-zip-compressed' ||
                    file.type === 'application/pdf'
                ) {
                    isPDF = true;
                }

                const isLt2M = file.size / 1024 / 1024 < 5;

                if (!isPDF) {
                    this.$message.error('Sólo se permiten documentos en formato PDF, imagen y archivos comprimidos');
                }

                if (!isLt2M) {
                    this.$message.error('Las imágenes no pueden exceder los 5MB');
                }
                if (isPDF && isLt2M) {
                    _this.$store.dispatch('loading/spinner', {msg: 'Subiendo archivo...', status: true}, {root: true});
                }

                return isPDF && isLt2M;
            },

            uploadedFile(data) {
                if (this.index != undefined) {
                    data.index = this.index;
                }
                this.$emit('fileInfo', data);
            },

            onError(err, file, fileList) {

                this.$store.dispatch('notifications/error', {msg: 'Archivo inválido'}, {root: true});

                console.log('onError UploadDocument',err.message);
            },

            onProgress(event, file, fileList) {
                let _this = this;

                if (event.percent == 100) {
                    setTimeout(() => {
                        this.$store.dispatch('loading/spinner', {}, {root: true});

                    }, 500);
                }
                this.$store.dispatch('loading/spinner', {}, {root: true});
            },

            deleteElement() {
                axios.post('/api/papers/delete-element').then(response => {
                    if (response.data.success) {

                        this.documentUrl = null;
                    }

                })
            }

        },

    }
</script>

<style>
    .time {
        font-size: 13px;
        color: #999;
    }

    .bottom {
        margin-top: 13px;
        line-height: 12px;
    }

    .button {
        padding: 0;
        float: right;
    }

    .image {
        width: 100%;
        display: block;
    }

    .clearfix:before,
    .clearfix:after {
        display: table;
        content: "";
    }

    .clearfix:after {
        clear: both
    }
</style>
